import { PickerView } from 'antd-mobile';
import { basicColumns } from './columnsData';

interface TimePickerViewProp {
  value?: any;
  onChange: (value?: Array<string | null>) => void;
}
// const getColumns = (value?: Array<string | null>) => {
//   const dayColumn = basicColumns[0];
//   const hourColumn = basicColumns[1];
//   let minuteColumn = basicColumns[2];
//   if (value && value[1] === '24') {
//     minuteColumn = minuteColumn.filter(item => item.value === ':00');
//   }
//   return [dayColumn, hourColumn, minuteColumn];
// };

const TimePickerView = ({ value, onChange }: TimePickerViewProp) => {
  return (
    <PickerView
      columns={basicColumns}
      // columns={getColumns(value)}
      value={value}
      onChange={(val, extend) => {
        onChange(val as Array<string | null>);
      }}
    />
  );
};
export default TimePickerView;
